/* HHL PWA registration + auto-update
 *
 * Registers /service-worker.js in production-like environments (or when
 * REACT_APP_ENABLE_SW=true) and installs an auto-update flow: as soon as a new
 * SW is detected, tell it to skipWaiting; when the controller changes, reload
 * the page so users always get the latest deploy.
 */

export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  // Register whenever the site is served over HTTPS or on localhost.
  const isSecure = window.location.protocol === "https:" || window.location.hostname === "localhost";
  if (!isSecure) return;

  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/service-worker.js");

      // If there's already a waiting worker, promote it now
      if (reg.waiting && navigator.serviceWorker.controller) {
        reg.waiting.postMessage({ type: "SKIP_WAITING" });
      }

      reg.addEventListener("updatefound", () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener("statechange", () => {
          if (nw.state === "installed" && navigator.serviceWorker.controller) {
            // A new version is ready. Tell it to activate immediately.
            nw.postMessage({ type: "SKIP_WAITING" });
          }
        });
      });

      // Reload as soon as the new SW takes control (only once)
      let refreshing = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      });

      // Check for updates on tab focus so long-lived tabs pick up new deploys
      window.addEventListener("focus", () => {
        reg.update().catch(() => {});
      });
    } catch (e) {
      // Non-fatal — the app still works without the SW
      // eslint-disable-next-line no-console
      console.warn("SW registration failed", e);
    }
  });
}
